import "rxjs/add/operator/map";
import { Component, SecurityContext } from '@angular/core';
import { NavController, NavParams, ToastController, Events, ActionSheetController, LoadingController, ModalController } from 'ionic-angular';
import { GlobalConfig } from '../../app/app.config';
import { AuthData } from '../../providers/auth';
import { EventData } from '../../providers/event';
import { DiaryData } from '../../providers/diary';
import { Translate } from '../../providers/translate';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EventSpeakerPage } from '../event-speaker/event-speaker';
import { EventReserveView } from '../event-reserve-view/event-reserve-view';
import { EventCommentPage } from '../event-comment/event-comment';
import { EventReservePage } from '../event-reserve/event-reserve';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-event-diary',
  templateUrl: 'event-diary.html'
})
export class EventDiaryPage {

  obs1: any;
  event: any;
  client: any;
  dataDiary: any;
  dataSpeakers: Array<any>;
  dataDiaryChild: Array<any>;
  comments: any = null;
  likeBloqued: any = null;
  likes: any;
  textTranslate: any;


  constructor(public navCtrl: NavController, public params: NavParams, public eventProvider: EventData, public toastCtrl: ToastController, public diaryProvider: DiaryData, public auth: AuthData, events: Events, public actionSheetCtrl: ActionSheetController, public loadingCtrl: LoadingController, public modalCtrl: ModalController, translate: Translate, public translateProvider: TranslateService, private _sanitizer: DomSanitizer) {

    translate.translateGroup(['Gracias por su Like', 'Comentarios Agenda', 'No se ha podido procesar la solicitud', 'Más opciones', 'Agregar a favoritos', 'Compartir', 'Cancelar', 'Debe iniciar sesión antes de continuar', 'Guardando en favoritos', 'Agenda guardada en favoritos', 'Agregar a mi agenda'])
    .then(result => {
      this.textTranslate = result;
    });

    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obs1 = this.eventProvider.getDiary(this.client, this.event.id, this.params.get('diary').id).subscribe((data: any) => {
      this.dataDiary = data;

      this.diaryProvider.getMyLike(this.client, this.dataDiary.id)
      .then((result: any) => {
        if (result.val()) {
          this.likeBloqued = 1;
        } else {
          this.likeBloqued = -1;
        }
      });

      if (this.dataDiary.isParent) {
        this.eventProvider.getData(this.client, this.event.id, 'Diary', {child: 'idEvtParent', value: this.dataDiary.id})
        .then((dataChild: any) => {
          this.dataDiaryChild = dataChild;
        });
      }
    });

    if (this.dataDiary.Speakers) {
      this.dataSpeakers = [];

      this.dataDiary.Speakers.forEach(sp => {
        this.diaryProvider.getSpeakerData(this.client, sp).then((speaker) => {
          this.dataSpeakers.push(speaker);
        });
      });
    }

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }

  sendLike(diary) {
    this.likeBloqued = null;
    this.diaryProvider.pushLike(this.client, diary.id, this.event.id)
    .then(result => {
      this.likeBloqued = 1;
      // Increase counter dashboard
      this.eventProvider.setTransactionDashboard(this.client, this.event, 'numLikesDiary');

      let toast = this.toastCtrl.create({
        message: this.textTranslate["Gracias por su Like"],
        duration: 2000,
        dismissOnPageChange: true
      });
      toast.present();
    });
  }

  viewComments(diary) {
    this.navCtrl.push(EventCommentPage, {type: 'diary', event: this.event, token2: diary.id, title: this.textTranslate['Comentarios Agenda'], client: this.client});
  }

  viewSpeaker(speaker) {
    this.navCtrl.push(EventSpeakerPage, {speaker: speaker, event: this.event, client: this.client});
  }

  viewDiary(diary) {
    this.navCtrl.push(EventDiaryPage, {event: this.event, diary: diary, client: this.client});
  }

  reserve(diary) {
    if (diary.reserve && diary.idReserve) {
      let modal = this.modalCtrl.create(EventReservePage, {client: this.client, reserveId: diary.idReserve, event: this.event, reserveChild: diary, type: 'Diary'});
      modal.present();

      modal.onDidDismiss((data) => {
        if (data) {
          let modal2 = this.modalCtrl.create(EventReserveView, {client: this.client, event: this.event, reserveData: data.reserveData});
          modal2.present();
        }
      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.textTranslate["No se ha podido procesar la solicitud"],
        duration: 2000,
        dismissOnPageChange: true
      });
      toast.present();
    }
  }

  moreOptions(diary) {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.textTranslate['Más opciones'],
      buttons: [
        {
          icon: 'heart',
          text: this.textTranslate['Agregar a favoritos'],
          handler: () => {
            this.favorite(diary);
          }
        },
        {
          icon: 'md-share',
          text: this.textTranslate['Compartir'],
          handler: () => {
            console.log('Archive clicked');
          }
        },
        {
          icon: 'md-calendar',
          text: this.textTranslate['Agregar a mi agenda'],
          handler: () => {
            this.addCalendar(diary);
          }
        },
        {
          icon: 'close',
          text: this.textTranslate['Cancelar'],
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

  favorite(diary){
    if (this.auth.getUser().isAnonymous) {
        let modal = this.modalCtrl.create(LoginPage, {client: this.client, event: this.event})
        modal.present();

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Debe iniciar sesión antes de continuar"],
          duration: 5000,
          position: 'top'
        });
        toast.present();
    } else {
      let loading = this.loadingCtrl.create({
        content: this.textTranslate['Guardando en favoritos']
      });
      loading.present();

      this.diaryProvider.pushFavorite(this.client, diary, this.event.id)
      .then(() => {
        // Increase counter dashboard
        this.eventProvider.setTransactionDashboard(this.client, this.event, 'numFavorites');

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Agenda guardada en favoritos"],
          duration: 3000,
          dismissOnPageChange: true
        });
        loading.dismiss();
        toast.present();
      })
      .catch(error => {
        let toast = this.toastCtrl.create({
          message: error,
          duration: 3000,
          dismissOnPageChange: true
        });
        loading.dismiss();
        toast.present();
      });
    }
  }

  addCalendar(diary){
    if (this.auth.getUser().isAnonymous) {
        let modal = this.modalCtrl.create(LoginPage, {client: this.client, event: this.event})
        modal.present();

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Debe iniciar sesión antes de continuar"],
          duration: 5000,
          position: 'top'
        });
        toast.present();
    } else {
      let start = "BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//www.marudot.com//iCal Event Maker";
      let end = "END:VCALENDAR";
      let data = "";
          data += "X-WR-CALNAME:" + diary.title[this.translateProvider.getDefaultLang()];
          data += "\n";
          data += "CALSCALE:GREGORIAN";
          data += "\n";
          data += "BEGIN:VTIMEZONE";
          data += "\n";
          data += "TZID:" + GlobalConfig._timezone;
          data += "\n";
          data += "TZURL:http://tzurl.org/zoneinfo-outlook/" + GlobalConfig._timezone;
          data += "\n";
          data += "X-LIC-LOCATION:" + GlobalConfig._timezone;
          data += "\n";
          data += "BEGIN:STANDARD";
          data += "\n";
          data += "TZOFFSETFROM:" + GlobalConfig._timezoneHour.replace(/:/g,"");
          data += "\n";
          data += "TZOFFSETTO:" + GlobalConfig._timezoneHour.replace(/:/g,"");
          data += "\n";
          data += "TZNAME:COT";
          data += "\n";
          data += "DTSTART:19700101T000000";
          data += "\n";
          data += "END:STANDARD";
          data += "\n";
          data += "END:VTIMEZONE";
          data += "\n";
          data += "BEGIN:VEVENT";
          data += "\n";
          data += "UID:reservas@rebus.com.co";
          data += "\n";
          data += 'DTSTART;TZID="' + GlobalConfig._timezone + '":' + diary.date.replace(/-/g,"") + 'T' + diary.start.replace(/:/g,"") + '00';
          data += "\n";
          data += 'DTEND;TZID="' + GlobalConfig._timezone + '":' + diary.date.replace(/-/g,"") + 'T' + diary.end.replace(/:/g,"") + '00';
          data += "\n";
          data += 'SUMMARY:' + diary.title[this.translateProvider.getDefaultLang()];
          data += "\n";
          data += 'URL:' + window.location.hostname;
          data += "\n";
          data += 'DESCRIPTION:' + diary.title[this.translateProvider.getDefaultLang()];
          data += "\n";
          // data += 'LOCATION:NA';
          // data += "\n";
          data += 'END:VEVENT';
          data += "\n";

      let convert = this._sanitizer.sanitize(SecurityContext.HTML, (start + '\n' + data + end));
      window.open("data:text/calendar;filename=filename.ics;charset=utf8," + encodeURIComponent(start + '\n' + data + end));
    }
  }

  closeListener() {
    console.log('Se eliminan los observable de page-diary', 'obs1');
    this.obs1.unsubscribe();
    // this.obs2.unsubscribe();
  }

  // Unsubsucribe observables on exit page
  ionViewWillUnload() {
    this.closeListener();
  }
}
// TODO: view bug where promise like and open comments
// TODO: dataSpeaker esperar ajuste de administrador. I don't remember
// end file



// WEBPACK FOOTER //
// ./src/pages/event-diary/event-diary.ts